var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6872 23C10.5997 23 9.57698 22.7755 8.61916 22.3265C7.67131 21.8775 6.85317 21.254 6.16474 20.4558C5.4763 19.6576 4.98243 18.7297 4.68311 17.6721L8.60419 16.6245C8.7339 17.1333 8.96338 17.5723 9.29263 17.9415C9.63186 18.3107 10.021 18.6 10.46 18.8095C10.909 19.0091 11.3679 19.1088 11.8368 19.1088C12.4554 19.1088 13.0192 18.9592 13.528 18.6599C14.0468 18.3605 14.4559 17.9565 14.7552 17.4476C15.0645 16.9388 15.2192 16.3751 15.2192 15.7565C15.2192 15.1379 15.0645 14.5742 14.7552 14.0653C14.4559 13.5565 14.0468 13.1524 13.528 12.8531C13.0192 12.5537 12.4554 12.4041 11.8368 12.4041C11.0786 12.4041 10.46 12.5338 9.98107 12.7932C9.50215 13.0426 9.14297 13.2821 8.90351 13.5116L5.46134 12.4639L6.11984 1H17.8831V4.80136H8.36474L9.80147 3.45442L9.35249 10.8476L8.66406 10.0095C9.20283 9.57052 9.81644 9.25125 10.5049 9.0517C11.1933 8.85215 11.8368 8.75238 12.4355 8.75238C13.7924 8.75238 14.9847 9.05669 16.0124 9.66531C17.05 10.2639 17.8582 11.0921 18.4368 12.1497C19.0255 13.1973 19.3198 14.3995 19.3198 15.7565C19.3198 17.1134 18.9656 18.3406 18.2573 19.4381C17.5489 20.5256 16.616 21.3937 15.4586 22.0422C14.3012 22.6807 13.0441 23 11.6872 23Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.a2322e76f0c97c243814686a575dc9df.svg";
export { ForwardRef as ReactComponent };